import SEOHead from '@/components/feature/SEOHead';
import Navbar from '@/components/feature/Navbar';
import HeroSection from './components/HeroSection';
import LatestUpdates from './components/LatestUpdates';
import CategoryShowcase from './components/CategoryShowcase';
import PopularComics from './components/PopularComics';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';

export default function Home() {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '八仔漫画网',
    url: 'https://bazaimanhua.com',
    description: '八仔漫画网在线免费阅读伪装学渣漫画全集，无需付费，无广告干扰，纯净阅读环境，让您沉浸于精彩剧情中。',
    inLanguage: 'zh-CN',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://bazaimanhua.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  return (
    <>
      <SEOHead
        title="伪装学渣漫画 - 在线免费阅读漫画全集 - 八仔漫画网"
        description="八仔漫画网在线免费阅读伪装学渣漫画全集，无需付费，无广告干扰，纯净阅读环境，让您沉浸于精彩剧情中。热门国漫、日漫一网打尽，每日更新，尽在八仔漫画网。"
        keywords="伪装学渣漫画,在线免费阅读,漫画全集,八仔漫画网,国漫在线,免费漫画,漫画阅读"
        canonicalUrl="https://bazaimanhua.com"
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      <ScrollToTop />
      <Navbar />
      <main>
        <HeroSection />
        <LatestUpdates />
        <CategoryShowcase />
        <PopularComics />
      </main>
      <Footer />
    </>
  );
}